const saldoReducer = (
    state = {
        jumlah_saldo    : 0
    },
    action
) => {
    switch (action.type) {        
        case 'UPDATE_JUMLAH_SALDO':

            return {
                ...state,
                jumlah_saldo: action.jumlah_saldo
            }
        default:
            return state;
    }
}

export default saldoReducer


// WEBPACK FOOTER //
// ./src/reducers/saldoReducer.js